import * as React from 'react'
import Footer from '../../../sections/footer'
import Hero from './components/hero'
import Reason from './components/reason'
import About1 from './components/about-1'
import About2 from './components/about-2'
import Quotes from '../../../sections/quotes'
import SectionFive from './components/action-footer'
import Faq from '../../../sections/simple-faq'
import Providers from '../../../sections/providers'
import WaveConainer from '../../../components/wave-container'
import Seo from '../../../components/seo'

export default function Consultant() {
  return (
    <>
      <Seo
        description="Nya Dooer är inte bara personliga seniora ekonomer och senaste AI-tekniken. Vi är mycket mer. Läs mer om allt du får när du väljer Dooer för din bokföring."
        image="https://www.dooer.com/images/og/og_index.jpg"
        title="Dooer för konsulter | Dooer"
        url="https://www.dooer.com/lp/konsult"
      />

      <Hero />
      <WaveConainer>
        <Reason />
      </WaveConainer>
      <About1 />
      <About2 />
      <Quotes />
      <Faq />
      <Providers />
      <SectionFive />
      <Footer inverted />
    </>
  )
}
